import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestHistoryRowDataI } from '../constants/constants';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SeriesOptionsType } from 'highcharts';
import * as Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HC_more from 'highcharts/highcharts-more';
import { LoaderService } from './loader.service';

HighchartsExporting(Highcharts);
HC_more(Highcharts)

    ; (function (Highcharts: any) {
        /**
         * Create a global getSVG method that takes an array of charts as an
         * argument
         */
        Highcharts.getSVG = function (charts: any) {
            // eslint-disable-next-line prefer-const
            let svgArr: any[] = [],
                top = 0,
                width = 0,
                endWidth = 0;

            Highcharts.each(charts, function (chart: any) {
                let svg = chart.getSVG(),
                    // Get width/height of SVG for export
                    // eslint-disable-next-line prefer-const
                    svgWidth = +svg.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1],
                    // eslint-disable-next-line prefer-const
                    svgHeight = +svg.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1];

                svg = svg.replace('<svg', '<g transform="translate(' + width + ', ' + top + ')" ');

                svg = svg.replace('</svg>', '</g>');

                width += svgWidth;
                endWidth = Math.max(endWidth, width);

                if (width === 2 * svgWidth) {
                    width = 0;
                    top += svgHeight;
                }

                svgArr.push(svg);
            });
            top += 400;
            return (
                '<svg height="' +
                top +
                '" width="' +
                endWidth +
                '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
                svgArr.join('') +
                '</svg>'
            );
        };

        /**
         * Create a global exportCharts method that takes an array of charts as an
         * argument, and exporting options as the second argument
         */
        Highcharts.exportCharts = function (charts: any, options: any) {
            charts.forEach(function (chart: any) {
                chart.update({
                    chart: {
                        borderColor: 'grey',
                        borderWidth: 1.5,
                    },
                    credits: {
                        enabled: false,
                    },
                });
            });

            // Merge the options
            options = Highcharts.merge(Highcharts.getOptions().exporting, options);

            // Post to export server
            Highcharts.post(options.url, {
                filename: options.filename || 'chart',
                type: options.type,
                width: options.width,
                svg: Highcharts.getSVG(charts),
            });
        };
    })(Highcharts);
@Injectable({
    providedIn: 'root',
})
export class DebtAnalysisService {
    public emitSelectedReqHistorySource: Subject<RequestHistoryRowDataI> = new Subject();
    public emitSelectedReqHistoryRecord$: Observable<RequestHistoryRowDataI> =
        this.emitSelectedReqHistorySource.asObservable();
    public selectedTicketRequestRow!: RequestHistoryRowDataI;
    private selectedRequestSubject: Subject<RequestHistoryRowDataI> = new Subject();
    private selectedTicketResponseSubject: Subject<any> = new Subject<any>();
    private apiServiceUrl = environment.apiUrl;
    deleteDebtModal = new BehaviorSubject<any>(null);
    private chartConfigDetails = [{ dataField: 'debtAnalysis' }, ,];
    private operationalGridData = new BehaviorSubject({});
    operationalGridDataSource = this.operationalGridData.asObservable();
    constructor(private http: HttpClient, private loader: LoaderService) { }
    public updateOperationalGridData(data: any) {
        this.operationalGridData.next(data);
    }
    public validate(clientName: string, file: File, itsmTool: string, emailId: any, notify: any ,submitterName:any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('clientName', clientName);
        formData.append('multipartFile', file, file.name);
        formData.append('itsmTool', itsmTool);
        formData.append('emailId', emailId);
        formData.append('notify', notify);
        formData.append('submitter',submitterName)

        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/validate`;
        return this.http.post(url, formData);
    }

    public submitDebtAnalysis(clientName: string, file: File, itsmTool: string, emailId: any, notify: any,submitterName:any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('clientName', clientName);
        formData.append('multipartFile', file, file.name);
        formData.append('itsmTool', itsmTool);
        formData.append('emailId', emailId);
        formData.append('notify', notify);
        formData.append('submitter',submitterName)
        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/submit`;
        return this.http.post(url, formData);
    }

    public getAllDebtAnalysis(): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/allRequestId`;
        return this.http.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
    /**
     * this will emit the selected request history
     * @param {RequestHistoryRowDataI} record
     * @memberof RequestHistoryService
     */
    public emitSelectedRequestHistory(record: RequestHistoryRowDataI): void {
        this.emitSelectedReqHistorySource.next(record);
    }

    public setSelectedTestDesignRow(row: RequestHistoryRowDataI) {
        this.selectedTicketRequestRow = row;
        // this.selectedRequestSubject.next(row);
        // if (row) {
        //   this.getSelectedDebtAnalysis(row.requestId).subscribe((res: any) => {
        //      this.selectedTicketResponseSubject.next(res);
        //   });
        // }
    }

    public getSelectedDebtAnalysis(requestId: string): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/reports?requestId=${requestId}`;
        return this.http.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    public UploadDebtAnalysisFile(requestId: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/download-file?requestId=${requestId}`;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
    public ProcessedDebtAnalysisFile(requestId: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/processed-file?requestId=${requestId}`;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
    public getSelectedDebtAnalysisResponse(): Observable<any> {
        return this.selectedTicketResponseSubject.asObservable();
    }

    public getSelectedRequest() {
        return this.selectedTicketRequestRow;
    }

    public makeAndExportCharts(data: any[], filename: string) {
        this.loader.show();
        setTimeout(() => {
            const allowedCategories = ['Operational', 'Technical', 'Functional'];
            const avoidableSeriesData = Array(allowedCategories.length).fill(0);
            const unavoidableSeriesData = Array(allowedCategories.length).fill(0);

            data.forEach((item: any) => {
                const categoryIndex = allowedCategories.indexOf(item.debt);
                if (categoryIndex !== -1) {
                    avoidableSeriesData[categoryIndex] = {
                        name: `${item.debt} (Avoidable)`,
                        y: item.avoidablePercentage,
                        color: '#6666CC'
                    };
                    unavoidableSeriesData[categoryIndex] = {
                        name: `${item.debt} (Unavoidable)`,
                        y: item.unavoidablePercentage,
                        color: '#008567'
                    };
                }
            });
            const debtAnalysis_ChartOptions: Highcharts.Options = {
                chart: {
                    type: 'column',
                },
                xAxis: {
                    categories: allowedCategories,
                    labels: {
                        style: {
                            fontWeight: '600',
                        },
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Debt',
                        style: {
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#000000'
                        },
                    },
                    stackLabels: {
                        enabled: true,
                    },
                },
                exporting: {
                    enabled: true
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: 'Debt Analysis',
                    margin: 50,
                    align: 'left',
                    y: 20,
                    x: 25
                },
                legend: {
                    align: 'center',
                    verticalAlign: 'bottom',
                    layout: 'horizontal',
                    itemMarginTop: 10,
                    itemWidth: 150,
                    itemStyle: {
                        fontWeight: 'normal',
                        fontSize: '14px',
                        color: '#333333',
                    },
                    itemHoverStyle: {
                        color: '#000000',
                    },
                },
                plotOptions: {
                    column: {
                        pointWidth: 50,
                        pointPadding: 0,
                        groupPadding: 0,
                        borderWidth: 0,
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true,
                            style: {
                                color: 'white',
                                textOutline: 'none',
                                fontSize: '8px'
                            },
                            formatter: function () {
                                return `${this.y}`;
                            }
                        },
                    },
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}%<br/>Total: {point.stackTotal}%'
                },
                series: [
                    {
                        type: 'column',
                        name: 'Avoidable',
                        data: avoidableSeriesData,
                        color: '#6666CC'
                    },
                    {
                        type: 'column',
                        name: 'Unavoidable',
                        data: unavoidableSeriesData,
                        color: '#008567'
                    },
                ],
            };
            const chart = Highcharts.chart(document.createElement('div'), debtAnalysis_ChartOptions)
                ; (Highcharts as any).exportCharts([chart], {
                    type: 'application/pdf',
                    filename: filename
                });

            setTimeout(() => {
                this.loader.hide();
            }, 500);
        }, 1000);
    }

    public deleteDebtAnalysis(requestId: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/debt/analysis/api/delete?requestId=${requestId}`;
        return this.http.delete(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
}
